// note(juan): this is a false-positive due to an ESlint error https://stackoverflow.com/questions/63961803/eslint-says-all-enums-in-typescript-app-are-already-declared-in-the-upper-scope
 
export enum structuredActivityStepId {
  overview,
  submitActivity,
}

export const STRUCTURED_ACTIVITY_STEPPER_TITLES: Record<structuredActivityStepId, string> = {
  [structuredActivityStepId.overview]: 'Practice Overview',
  [structuredActivityStepId.submitActivity]: 'Submit Activity',
};
